export const getRootZoneAverage = (rootZoneSeries: (number | null)[]): number | null => {
  const values = rootZoneSeries.filter((value) => value !== null)

  return values.length === 0 ? null : values.reduce((sum, value) => sum + value, 0) / values.length
}
